import { addQueryArgs } from '@wordpress/url';

const contentNode = document.querySelector( '.realpress-agent-property' );
let containerNode, termListNodes, currentActiveNode;
//Loadmore
const loadMoreWrapperNode = contentNode.querySelector( '.realpress-load-more' );
let loadmoreBtnNode, loadingNode;

//infinite scroll
const infiniteScrollNode = contentNode.querySelector( '.realpress-infinite-scroll' );
let infiniteLoadingNode;
//-----------

const authorId = REALPRESS_AGENT_DETAIL_OBJECT.user_id || '';
const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
const paginationType = REALPRESS_GLOBAL_OBJECT.pagination_type || '';

let query = {};
let isFetching = false;
let nextPage = null;
let activeTermId;

const init = () => {
	query = {
		author_id: authorId,
		orderby: 'date',
		order: 'desc',
		taxonomy: 'realpress-status',
		template: 'agent_detail',
	};

	if ( typeof REALPRESS_GLOBAL_OBJECT.pll_current_lang !== 'undefined' ) {
		query = { ...query, pll_current_lang: REALPRESS_GLOBAL_OBJECT.pll_current_lang };
	}

	if ( typeof REALPRESS_GLOBAL_OBJECT.wpml_current_lang !== 'undefined' ) {
		query = { ...query, wpml_current_lang: REALPRESS_GLOBAL_OBJECT.wpml_current_lang };
	}

	containerNode = contentNode.querySelector( '.realpress-property-container' );
};
const realpressAgentProperty = () => {
	if ( ! contentNode ) {
		return;
	}

	init();

	if ( ! containerNode ) {
		return;
	}

	termListNodes = contentNode.querySelectorAll( '.status-list-item' );

	if ( ! termListNodes ) {
		return;
	}

	//Loadmore
	if ( loadMoreWrapperNode ) {
		loadmoreBtnNode = loadMoreWrapperNode.querySelector( '.realpress-load-more-btn' );
		loadingNode = loadMoreWrapperNode.querySelector( '.realpress-loading-display' );
	}

	//Infinite Scroll
	if ( infiniteScrollNode ) {
		infiniteLoadingNode = infiniteScrollNode.querySelector( '.realpress-loading-display' );
	}

	handleTermQuery();
	getProperties( query );
	pagination();
};

const handleTermQuery = () => {
	activeTermId = JSON.parse( localStorage.getItem( 'realpress_agent_active_term' ) );

	if ( activeTermId == null ) {
		activeTermId = {};
	}

	if ( ! activeTermId[ authorId ] ) {
		termListNodes[ 0 ].classList.add( 'active' );
		activeTermId[ authorId ] = termListNodes[ 0 ].getAttribute( 'data-term-id' );
		currentActiveNode = termListNodes[ 0 ];
		localStorage.setItem( 'realpress_agent_active_term', JSON.stringify( activeTermId ) );
	} else {
		for ( let j = 0; j < termListNodes.length; j++ ) {
			const item = termListNodes[ j ];
			const termId = item.getAttribute( 'data-term-id' );
			if ( termId === activeTermId[ authorId ] ) {
				if ( ! item.classList.contains( 'active' ) ) {
					item.classList.add( 'active' );
					currentActiveNode = item;
					break;
				}
			}
		}
	}

	[ ...termListNodes ].map( ( termListNode ) => {
		termListNode.addEventListener( 'click', function() {
			if ( termListNode === currentActiveNode ) {
				return;
			}

			currentActiveNode.classList.remove( 'active' );
			currentActiveNode = termListNode;
			currentActiveNode.classList.add( 'active' );
			activeTermId[ authorId ] = currentActiveNode.getAttribute( 'data-term-id' );
			localStorage.setItem( 'realpress_agent_active_term', JSON.stringify( activeTermId ) );
			query = { ...query, term_id: activeTermId[ authorId ] };
			getProperties( query );
		} );
	} );

	query = { ...query, term_id: activeTermId[ authorId ] };
};

const getProperties = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}

	if ( containerNode.getAttribute( 'data-loop-item-id' ) ) {
		queryParam = { ...queryParam, 'loop-item-id': containerNode.getAttribute( 'data-loop-item-id' ) };
	}

	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/properties', queryParam ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			if ( isLoadmore ) {
				containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
			} else {
				containerNode.innerHTML = res.data.content;
			}
		} else {
			if ( loadMoreWrapperNode ) {
				loadMoreWrapperNode.style.display = 'none';
			}
			if ( res.msg && isLoadmore === false ) {
				containerNode.innerHTML = `<p>${ res.msg }</p>`;
			}
		}

		renderPagination( res );
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		containerNode.style.opacity = 1;
	} );
};

const renderPagination = ( res ) => {
	if ( paginationType === 'standard' ) {
		if ( res.data.pagination !== undefined ) {
			contentNode.querySelector( '.realpress-pagination' ).innerHTML = res.data.pagination;
		} else {
			contentNode.querySelector( '.realpress-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			contentNode.querySelector( '.realpress-from-to' ).innerHTML = res.data.from_to;
		} else {
			contentNode.querySelector( '.realpress-from-to' ).innerHTML = '';
		}
	}

	if ( paginationType === 'loadmore' ) {
		if ( res.data.pagination === undefined ) {
			nextPage = null;
			return;
		}

		loadmoreBtnNode.innerHTML = res.data.pagination;
		loadingNode.style.display = 'none';

		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}

	if ( paginationType === 'infinite_scroll' ) {
		infiniteLoadingNode.style.display = 'none';
		isFetching = false;
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}
};

const pagination = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const item = target.closest( 'a' );
		if ( paginationType === 'standard' ) {
			if ( ! item ) {
				return;
			}

			if ( ! item.getAttribute( 'data-page' ) ) {
				return;
			}

			const paginationNode = target.closest( '.realpress-pagination' );
			if ( ! paginationNode ) {
				return;
			}
			event.preventDefault();
			const page = item.getAttribute( 'data-page' );
			query = { ...query, page };
			getProperties( query );
			contentNode.scrollIntoView( { behavior: 'smooth' } );
		}

		if ( paginationType === 'loadmore' ) {
			if ( target.parentNode !== loadmoreBtnNode ) {
				return;
			}

			event.preventDefault();
			target.remove();
			loadingNode.style.display = 'block';
			query = { ...query, page: nextPage };
			getProperties( query, true );
		}
	} );

	if ( paginationType === 'infinite_scroll' ) {
		window.addEventListener( 'scroll', ( event ) => {
			getScrollData();
		} );
	}
};

const getScrollData = () => {
	const distance = infiniteScrollNode.getBoundingClientRect().top - window.innerHeight;

	if ( isFetching === false && distance < 0 && nextPage ) {
		isFetching = true;
		infiniteLoadingNode.style.display = 'block';
		query = { ...query, page: nextPage };
		getProperties( query, true );
	}
};

export default realpressAgentProperty;
